import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Hydrate prerendered HTML when available; otherwise mount fresh.
// Prerendered pages have real content inside #root; unprerendered fallbacks
// (dev, admin, dynamic paths) have an empty #root and use createRoot.
if (rootEl && rootEl.hasChildNodes() && rootEl.firstElementChild) {
  ReactDOM.hydrateRoot(rootEl, tree, {
    onRecoverableError: (err, info) => {
      // Surface hydration mismatches to the console with full context so we
      // can trace them; console-only, no user impact.
      if (typeof console !== "undefined") {
        console.error("[hydration]", err?.message || String(err), info);
      }
    },
  });
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
